module.exports = __webpack_public_path__ + "static/media/hero-question-b.1e981fe2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Sections/Hero/hero-question-b.svg
// module id = 89
// module chunks = 0